import React, { Component } from 'react';
import { connect } from 'react-redux';
import { priceState, priceDispatcher, combineStates, siteSettingsState, identityState } from '../../store';
import { BusyContainer } from '..';
import { PropTypes } from 'prop-types';
import { FormattedPrice } from '..';
import { convertToLineItem, getAccessories, getConfigurationPrice, getProductPrice,getNSTPrice, PricingModule } from '../../util';
import { translate } from '../../services'

export class ProductPriceComponent extends Component {
  constructor() {
    super();
    this.getCurrency = this.getCurrency.bind( this );
  }
  componentDidMount() {
    //// if currentView is coming from ProductsViewer comp, don't call the func to reduce unnecessary api calls
    if (this.props.currentView !== 'ProductsViewer') {
    this.getMissingPricesCodes( this.props );
    }
  }
  
  componentDidUpdate() {
    if (this.props.currentView !== 'ProductsViewer') {
    this.getMissingPricesCodes( this.props );
    }
  }

  getMissingPricesCodes( props ) {
    const { prices, product, products, user } = props;
    const requiredPricesInfo = [];

    if( product && products ) {
      console.warn( 'provided products and product to ProductPrice' );
    }
   
    if ( !product && !products ) {
      // nothing to do here
      return;
    }

    const items = this.getItems();

    for( let item of items ) {
      if ( !prices[item.name] ) {
        Object.keys( item ).length && requiredPricesInfo.push( item );
	if(item.fgProduct && item.fgProduct.length>0){
          Object.keys( item.fgProduct[0] ).length && requiredPricesInfo.push( item.fgProduct[0] );
        }
      }
      if(item.fgProduct && item.fgProduct.length>0 && !prices[item.fgProduct[0].Name]){
        Object.keys( item.fgProduct[0] ).length && requiredPricesInfo.push( item.fgProduct[0] );
      }
      if( item.configuration ) {
        const accessories = getAccessories( item );
  
        for( let accessory of accessories ) {
          if( !prices[accessory] ) {
            requiredPricesInfo.push(accessory);
            // const accessoryProduct = this.props.productsState[accessory];
            // accessoryProduct && Object.keys( accessoryProduct ).length && requiredPricesInfo.push( accessoryProduct );
          
          }
        }
      }
    }

    requiredPricesInfo.any() && this.props.getPrices( requiredPricesInfo.map( product =>convertToLineItem(product,user) ) );
  }

  getCurrency() {
    const { prices } = this.props;
    const items = this.getItems();
    //const currencyHolder = Object.keys( prices ).find( key => prices[key] && prices[key].rateUnit );
    const currencyHolder = items.length > 0 ? items.firstOrDefault().name: Object.keys( prices ).find( key => prices[key] && prices[key].rateUnit );
    return currencyHolder && prices[currencyHolder] && prices[currencyHolder].rateUnit;
  }

  getPrice( priceProperty ) {
    const { fromCart, prices, product, products, lastAddedItem, user ,skipLooseAcc=false,fromSelect,fromConfigFooter,fromSearch,fromCartFooter
    } = this.props;
    const items = this.getItems();
    let price = 0;
    const fromCbol = user.authenticationType === 'Cbol' ? true : false;
    for( let item of items ) {
      if(item.configurableProduct || (item.FG && item.FG!="待开") || (item.superCodeLSO && item.superCodeLSO!="待开") ){
        price+=getNSTPrice(item,prices,fromCart,fromCartFooter,fromSelect,fromConfigFooter,skipLooseAcc,priceProperty, fromSearch,lastAddedItem)
      }
      else if( ( !item.isExpanded || products ) && item.configuration  ) {  
        price += getConfigurationPrice( item, prices, priceProperty, fromCart, lastAddedItem, fromCbol,fromConfigFooter,skipLooseAcc );
      } else if( prices[item.name] ) {
        price += getProductPrice( item, prices, priceProperty, lastAddedItem || ( fromCart && !item.configuration ) );
      } else{
        price += getProductPrice( item, [], priceProperty, lastAddedItem || ( fromCart && !item.configuration ) );
      }
    }
    return price;
  }

  getPricePerUnit( priceProperty ) {
    const { fromCart, prices, product, products, lastAddedItem, siteSettings } = this.props;
    const items = products || [product];
    let price = 0;

    for( let item of items ) {
      if( ( !item.isExpanded || products ) && item.configuration ) {  
        price += getConfigurationPrice( item, prices, priceProperty, fromCart, lastAddedItem ) ;
      }
      //passing prices parameter instead of blank array as prices has to be fetched from prices redux store in case of SAP also
      else if( prices[item.name] && siteSettings.pricingModule == 1 ) {
        price += getProductPrice( item, prices, priceProperty, lastAddedItem || ( fromCart && !item.configuration ) ) * prices[item.name].priceUnit;
      } else if( prices[item.name] ) {
        price += getProductPrice( item, prices, priceProperty, lastAddedItem || ( fromCart && !item.configuration ) ) * prices[item.name].priceUnit;
      }
    }

    return price;
  }

  isLoading() {
    // const { prices, product, products, siteSettings } = this.props;
    // return siteSettings.pricingModule === 0
    //   ? false 
    //   : this.getItems().any( item => !prices[item.name] || prices[item.name].loading );
    return false
  }

  isEstimatedPrice( priceType ) {
    const { prices, product, products, fromCart } = this.props;
    return  this.getItems().map( product => product.name ).some( product => !prices[product] || prices[product].isValid === false || prices[product][priceType] === 0 );
  }
  
  getItems( ) {
    const { product, products, additionalProduct, fromConfigHeader,fromAccessoriesCart } = this.props;
    const itemsToShowPrice = products ? products 
    :!fromAccessoriesCart? product && product.additionalProducts && product.additionalProducts.length > 1 ? [ ...product.additionalProducts ] : [product]: [product];
    if( additionalProduct && fromConfigHeader ){
      itemsToShowPrice.push( additionalProduct );
    }
    return itemsToShowPrice.filter( m => m.name );
  }

  render() {
    const { fromCart, prices, showListPrice,layout, showConfiguratorButtonAtTop, showNetPrice, siteSettings, product, products, showPricePerUnit, user, priceSize, additionalProduct, fromConfigHeader } = this.props;
    if ( !product && !products ) {
      return null;
    }
    let displayListPrice = showListPrice || !showListPrice && !showNetPrice && ( user.properties.ViewListPrice == 'true' || siteSettings.viewListPrice );
    let displayNetPrice = showNetPrice || !showListPrice && !showNetPrice && ( user.properties.ViewNetPrice =='true' || siteSettings.viewNetPrice );
    const isEstimated = ( displayListPrice || displayNetPrice ) && this.isEstimatedPrice( prices.type  ) && !siteSettings.isPriceEstimationNotRequired;
    if( siteSettings.showPriceSwitch) {
      displayListPrice = prices.type === 'listPrice' ? showListPrice || displayListPrice : showListPrice;
      displayNetPrice = prices.type === 'netPrice' ? showNetPrice || displayNetPrice : showNetPrice;
    }
    const showBothPrices = displayListPrice && displayNetPrice;
    const priceType = showBothPrices ? 'netPrice' : displayNetPrice ? 'netPrice' : displayListPrice ? 'listPrice' : prices.type;
    const showBothPricesInConfig = showBothPrices && siteSettings.showBothPricesInConfigPage;

    // styles and label changes if configurator button shifted to the top
    const className = "product-price " + (showConfiguratorButtonAtTop ? "product-price-right" : "")+(layout && layout.className==="bold-font"?"row-product-price":"");
    const translationPhrase = showConfiguratorButtonAtTop ? this.props.translationPhrase || "" : "";   
    const priceClass = showConfiguratorButtonAtTop ? 'price-left' : ''; 

    return !PricingModule.showPrice( siteSettings.pricingModule ) 
      ? null 
      : fromConfigHeader && additionalProduct && additionalProduct[0] && !additionalProduct[0]?.dummyCode && !showBothPricesInConfig
      ? <BusyContainer className={className} isBusy={ this.isLoading() }>
        { <FormattedPrice priceClass={priceClass} price={ getProductPrice( product , prices, priceType , fromCart ) }  currency={ this.getCurrency() } isEstimated={ isEstimated  } fromheader={ fromConfigHeader && additionalProduct } /> }
        { <h3 className="header-price">&nbsp;&#43;&nbsp;</h3>}
        { <FormattedPrice priceClass={priceClass} price={ getProductPrice( additionalProduct , prices, priceType, fromCart ) }  currency={ this.getCurrency() } isEstimated={ isEstimated } fromheader={ fromConfigHeader && additionalProduct } /> }
      </BusyContainer>
      :  fromConfigHeader && showBothPricesInConfig
      ? 
      <BusyContainer className={className} isBusy={ this.isLoading() }>
        <div>
          <div className='display-flex'>
          { displayListPrice && translate( translationPhrase + "LIST_PRICE" ) }&nbsp;
          { displayListPrice && <FormattedPrice priceClass={priceClass} price={ getProductPrice( product , prices, 'listPrice' , fromCart ) }  currency={ this.getCurrency() } isEstimated={ isEstimated } fromheader={ !fromConfigHeader } showBothPricesInConfig={ showBothPricesInConfig } /> }
          { displayListPrice && additionalProduct && <h3 className="header-price">&nbsp;&#43;&nbsp;</h3>}
          { displayListPrice && additionalProduct && <FormattedPrice priceClass={priceClass} price={ getProductPrice( additionalProduct , prices, 'listPrice', fromCart ) }  currency={ this.getCurrency() } isEstimated={ isEstimated } fromheader={ fromConfigHeader } showBothPricesInConfig={ showBothPricesInConfig } /> }
          </div>
          <div className='display-flex'>
          { displayNetPrice && translate( translationPhrase + "NET_PRICE" ) }&nbsp;
          { displayNetPrice && <FormattedPrice priceClass={priceClass} price={ getProductPrice( product , prices, 'netPrice' , fromCart ) }  currency={ this.getCurrency() } isEstimated={ isEstimated } fromheader={ !fromConfigHeader && additionalProduct } showBothPricesInConfig={ showBothPricesInConfig } /> }
          { displayNetPrice && additionalProduct && <h3 className="header-price">&nbsp;&#43;&nbsp;</h3>}
          { displayNetPrice && additionalProduct && <FormattedPrice priceClass={priceClass} price={ getProductPrice( additionalProduct , prices, 'netPrice', fromCart ) }  currency={ this.getCurrency() } isEstimated={ isEstimated } fromheader={ fromConfigHeader && additionalProduct } showBothPricesInConfig={ showBothPricesInConfig } /> }
          </div>
        </div>
      </BusyContainer>
      : this.props.fromConfigFooter && showBothPricesInConfig
      ? <BusyContainer className={className} isBusy={ this.isLoading() }>
        <div>
          <div className='display-flex'>
          { displayListPrice && translate( translationPhrase + "LIST_PRICE" ) }&nbsp;
          { displayListPrice && <FormattedPrice priceClass={priceClass} price={ this.getPrice( 'listPrice' ) }  currency={ this.getCurrency() } isEstimated={ isEstimated } /> }
          </div>
          <div className='display-flex'>
          { displayNetPrice && translate( translationPhrase + "NET_PRICE" ) }&nbsp;
          { displayNetPrice && <FormattedPrice priceClass={priceClass} price={ this.getPrice( 'netPrice' ) }  currency={ this.getCurrency() } isEstimated={ isEstimated } /> }
          </div>
        </div>
      </BusyContainer>
      :<BusyContainer className={className} isBusy={ this.isLoading() }>
        <div>
          <div className='display-flex'>
           { !showPricePerUnit && !showBothPrices && displayListPrice && showConfiguratorButtonAtTop &&
            translate( translationPhrase + "LIST_PRICE" )
           }
            { !showPricePerUnit && !showBothPrices && displayListPrice && <FormattedPrice priceClass={priceClass} priceSize={ showConfiguratorButtonAtTop ? '' : priceSize } price={ this.getPrice( 'listPrice' ) } currency={ this.getCurrency() } isEstimated={ isEstimated } fromFooter={this.props.fromConfigFooter} excludeLooseAccPrice={this.props.excludeLooseAccPrice} fromCart={this.props.fromCart} /> }
            { !showPricePerUnit && displayNetPrice && showConfiguratorButtonAtTop &&
            translate( translationPhrase + "NET_PRICE" )  
            } 
            { !showPricePerUnit && displayNetPrice && <FormattedPrice priceClass={priceClass} priceSize={ showConfiguratorButtonAtTop ? '' : priceSize } price={ this.getPrice( 'netPrice' ) } currency={ this.getCurrency() } isEstimated={ isEstimated } /> }
            { showPricePerUnit && <FormattedPrice priceClass={priceClass} priceSize={ priceSize } price={ this.getPricePerUnit( 'listPrice' ) }  currency={ this.getCurrency() } isEstimated={ isEstimated } /> }
          </div>
        </div>
      </BusyContainer>;
  }
}

ProductPriceComponent.propTypes = {
  getPrices: PropTypes.func.isRequired,
  price: PropTypes.number,
  prices: PropTypes.shape( {
    type: PropTypes.string.isRequired
  } ),
  product: PropTypes.shape( {
    configuration: PropTypes.shape( {} ),  
    name: PropTypes.string
  } ),
  products: PropTypes.arrayOf( PropTypes.shape( {} ) ),
  productsState: PropTypes.shape( {} ),
  showListPrice: PropTypes.bool, 
  showNetPrice: PropTypes.bool,
  siteSettings: PropTypes.shape( {
    pricingModule: PropTypes.number.isRequired
  } )
};

const mergedStateProvider = ( stateProperty, outputProperty, getObjects, getItem, getTitle, ...mergedWith ) => state => {
  const curState = state[stateProperty];
  if ( !curState ) {
    return { [outputProperty || stateProperty]: {} };
  }
  return { 
    [outputProperty || stateProperty]: getObjects( curState ).reduce( ( agg, item ) => {
      const entity = getItem( curState, item );
      const title = getTitle( curState, item );
      if ( !agg[title] ) {
        agg[title] = Object.assign( {}, entity, ...mergedWith.map( key => state[key] && state[key][title] ).filter( i => !!i ) );
      }
      return agg;
    }, {} )
  };
};

export const ProductPrice = connect( combineStates( 
  identityState,
  priceState, 
  siteSettingsState,
  identityState, 
  mergedStateProvider( 
    'productsStore', 
    'productsState', 
    state => Object.keys( state ), 
    ( state, key ) => state[key],
    ( _, key ) => key,
    'prices' )
), priceDispatcher )( ProductPriceComponent );